/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Request_BlockedInputs */

const es_co2_error_request_blocked = /** @type {(inputs: Error_Request_BlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No pudimos enviar el contenido; puede ser demasiado grande o haber sido bloqueado. Acórtalo e inténtalo de nuevo.`)
};

/**

* @param {Error_Request_BlockedInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const error_request_blocked = /** @type {((inputs?: Error_Request_BlockedInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Request_BlockedInputs, { locale?: "es-CO" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_error_request_blocked(inputs)
});